// Base user entities for demo purposes
export interface MockUser {
  id: string;
  name: string;
  email: string;
  avatar?: string;
  role: string;
  department: string;
  title: string;
  phone?: string;
  location?: string;
  status?: 'active' | 'away' | 'busy' | 'offline';
  joinedAt: Date;
  bio?: string;
  skills?: string[];
}

export const mockUsers: MockUser[] = [
  {
    id: 'u1',
    name: 'John Doe',
    email: 'john.doe@company.com',
    avatar: '/avatars/1.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Senior Frontend Developer',
    phone: '+1 234 567 8900',
    location: 'New York, NY',
    status: 'active',
    joinedAt: new Date('2022-01-15'),
    bio: 'Passionate about building great user experiences',
    skills: ['React', 'TypeScript', 'UI/UX'],
  },
  {
    id: 'u2',
    name: 'Jane Smith',
    email: 'jane.smith@company.com',
    avatar: '/avatars/2.jpg',
    role: 'Manager',
    department: 'Engineering',
    title: 'Engineering Manager',
    phone: '+1 234 567 8901',
    location: 'San Francisco, CA',
    status: 'active',
    joinedAt: new Date('2021-03-10'),
    bio: 'Leading teams to build amazing products',
    skills: ['Leadership', 'Strategy', 'Agile'],
  },
  {
    id: 'u3',
    name: 'Alice Johnson',
    email: 'alice.johnson@company.com',
    avatar: '/avatars/3.jpg',
    role: 'Designer',
    department: 'Design',
    title: 'Senior UI/UX Designer',
    phone: '+1 234 567 8902',
    location: 'Austin, TX',
    status: 'active',
    joinedAt: new Date('2022-06-20'),
    bio: 'Creating beautiful and functional designs',
    skills: ['Figma', 'UI Design', 'Prototyping'],
  },
  {
    id: 'u4',
    name: 'Bob Williams',
    email: 'bob.williams@company.com',
    avatar: '/avatars/4.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Backend Developer',
    phone: '+1 234 567 8903',
    location: 'Seattle, WA',
    status: 'busy',
    joinedAt: new Date('2021-09-05'),
    bio: 'Building scalable backend systems',
    skills: ['Node.js', 'PostgreSQL', 'API Design'],
  },
  {
    id: 'u5',
    name: 'Charlie Brown',
    email: 'charlie.brown@company.com',
    avatar: '/avatars/5.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Full Stack Developer',
    phone: '+1 234 567 8904',
    location: 'Boston, MA',
    status: 'active',
    joinedAt: new Date('2022-11-12'),
    bio: 'Jack of all trades, master of some',
    skills: ['React', 'Node.js', 'MongoDB'],
  },
  {
    id: 'u6',
    name: 'Diana Prince',
    email: 'diana.prince@company.com',
    avatar: '/avatars/6.jpg',
    role: 'Product Manager',
    department: 'Product',
    title: 'Senior Product Manager',
    phone: '+1 234 567 8905',
    location: 'Los Angeles, CA',
    status: 'active',
    joinedAt: new Date('2020-04-18'),
    bio: 'Defining product vision and strategy',
    skills: ['Product Strategy', 'User Research', 'Analytics'],
  },
  {
    id: 'u7',
    name: 'Ethan Hunt',
    email: 'ethan.hunt@company.com',
    avatar: '/avatars/7.jpg',
    role: 'QA Engineer',
    department: 'Engineering',
    title: 'QA Lead',
    phone: '+1 234 567 8906',
    location: 'Chicago, IL',
    status: 'away',
    joinedAt: new Date('2021-07-22'),
    bio: 'Ensuring quality in every release',
    skills: ['Testing', 'Automation', 'CI/CD'],
  },
  {
    id: 'u8',
    name: 'Fiona Green',
    email: 'fiona.green@company.com',
    avatar: '/avatars/8.jpg',
    role: 'Designer',
    department: 'Design',
    title: 'Product Designer',
    phone: '+1 234 567 8907',
    location: 'Portland, OR',
    status: 'active',
    joinedAt: new Date('2022-02-14'),
    bio: 'Crafting delightful user experiences',
    skills: ['UX Research', 'Wireframing', 'User Testing'],
  },
  {
    id: 'u9',
    name: 'George Miller',
    email: 'george.miller@company.com',
    avatar: '/avatars/9.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Junior Developer',
    phone: '+1 234 567 8908',
    location: 'Denver, CO',
    status: 'active',
    joinedAt: new Date('2023-01-09'),
    bio: 'Learning and growing every day',
    skills: ['JavaScript', 'HTML', 'CSS'],
  },
  {
    id: 'u10',
    name: 'Hannah Davis',
    email: 'hannah.davis@company.com',
    avatar: '/avatars/10.jpg',
    role: 'Manager',
    department: 'Design',
    title: 'Design Manager',
    phone: '+1 234 567 8909',
    location: 'Miami, FL',
    status: 'active',
    joinedAt: new Date('2020-08-30'),
    bio: 'Building and leading design teams',
    skills: ['Design Leadership', 'Team Management', 'Strategy'],
  },
  {
    id: 'u11',
    name: 'Ian Foster',
    email: 'ian.foster@company.com',
    avatar: '/avatars/11.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'DevOps Engineer',
    phone: '+1 234 567 8910',
    location: 'Phoenix, AZ',
    status: 'busy',
    joinedAt: new Date('2021-12-01'),
    bio: 'Automating infrastructure and deployments',
    skills: ['AWS', 'Docker', 'Kubernetes'],
  },
  {
    id: 'u12',
    name: 'Julia Roberts',
    email: 'julia.roberts@company.com',
    avatar: '/avatars/12.jpg',
    role: 'Marketing',
    department: 'Marketing',
    title: 'Marketing Manager',
    phone: '+1 234 567 8911',
    location: 'Nashville, TN',
    status: 'active',
    joinedAt: new Date('2022-03-15'),
    bio: 'Driving growth through marketing',
    skills: ['Digital Marketing', 'SEO', 'Content Strategy'],
  },
  {
    id: 'u13',
    name: 'Kevin Hart',
    email: 'kevin.hart@company.com',
    avatar: '/avatars/13.jpg',
    role: 'Sales',
    department: 'Sales',
    title: 'Account Executive',
    phone: '+1 234 567 8912',
    location: 'Atlanta, GA',
    status: 'active',
    joinedAt: new Date('2021-05-20'),
    bio: 'Building relationships and closing deals',
    skills: ['Sales', 'Negotiation', 'CRM'],
  },
  {
    id: 'u14',
    name: 'Laura Palmer',
    email: 'laura.palmer@company.com',
    avatar: '/avatars/14.jpg',
    role: 'HR',
    department: 'Human Resources',
    title: 'HR Manager',
    phone: '+1 234 567 8913',
    location: 'Philadelphia, PA',
    status: 'active',
    joinedAt: new Date('2020-02-11'),
    bio: 'Supporting our people and culture',
    skills: ['Recruitment', 'Employee Relations', 'HR Strategy'],
  },
  {
    id: 'u15',
    name: 'Michael Scott',
    email: 'michael.scott@company.com',
    avatar: '/avatars/15.jpg',
    role: 'Manager',
    department: 'Sales',
    title: 'Sales Manager',
    phone: '+1 234 567 8914',
    location: 'Scranton, PA',
    status: 'active',
    joinedAt: new Date('2019-01-05'),
    bio: 'Leading the sales team to success',
    skills: ['Leadership', 'Sales Strategy', 'Team Building'],
  },
  {
    id: 'u16',
    name: 'Nina Anderson',
    email: 'nina.anderson@company.com',
    avatar: '/avatars/16.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Mobile Developer',
    phone: '+1 234 567 8915',
    location: 'San Diego, CA',
    status: 'offline',
    joinedAt: new Date('2022-08-17'),
    bio: 'Building mobile experiences',
    skills: ['React Native', 'iOS', 'Android'],
  },
  {
    id: 'u17',
    name: 'Oscar Martinez',
    email: 'oscar.martinez@company.com',
    avatar: '/avatars/17.jpg',
    role: 'Finance',
    department: 'Finance',
    title: 'Financial Analyst',
    phone: '+1 234 567 8916',
    location: 'Dallas, TX',
    status: 'active',
    joinedAt: new Date('2020-10-25'),
    bio: 'Analyzing financial data and trends',
    skills: ['Financial Analysis', 'Excel', 'Reporting'],
  },
  {
    id: 'u18',
    name: 'Pam Beesly',
    email: 'pam.beesly@company.com',
    avatar: '/avatars/18.jpg',
    role: 'Designer',
    department: 'Design',
    title: 'Graphic Designer',
    phone: '+1 234 567 8917',
    location: 'Scranton, PA',
    status: 'active',
    joinedAt: new Date('2021-04-12'),
    bio: 'Creating visual content',
    skills: ['Graphic Design', 'Illustration', 'Branding'],
  },
  {
    id: 'u19',
    name: 'Quincy Jones',
    email: 'quincy.jones@company.com',
    avatar: '/avatars/19.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Data Engineer',
    phone: '+1 234 567 8918',
    location: 'Minneapolis, MN',
    status: 'active',
    joinedAt: new Date('2022-07-08'),
    bio: 'Building data pipelines and infrastructure',
    skills: ['Python', 'SQL', 'Data Warehousing'],
  },
  {
    id: 'u20',
    name: 'Rachel Green',
    email: 'rachel.green@company.com',
    avatar: '/avatars/20.jpg',
    role: 'Marketing',
    department: 'Marketing',
    title: 'Content Strategist',
    phone: '+1 234 567 8919',
    location: 'New York, NY',
    status: 'active',
    joinedAt: new Date('2021-11-03'),
    bio: 'Creating compelling content strategies',
    skills: ['Content Marketing', 'Copywriting', 'SEO'],
  },
  {
    id: 'u21',
    name: 'Sam Wilson',
    email: 'sam.wilson@company.com',
    avatar: '/avatars/21.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Security Engineer',
    phone: '+1 234 567 8920',
    location: 'Washington, DC',
    status: 'busy',
    joinedAt: new Date('2020-09-14'),
    bio: 'Protecting systems and data',
    skills: ['Security', 'Penetration Testing', 'Compliance'],
  },
  {
    id: 'u22',
    name: 'Tina Turner',
    email: 'tina.turner@company.com',
    avatar: '/avatars/22.jpg',
    role: 'Support',
    department: 'Customer Success',
    title: 'Customer Success Manager',
    phone: '+1 234 567 8921',
    location: 'Las Vegas, NV',
    status: 'active',
    joinedAt: new Date('2022-05-19'),
    bio: 'Ensuring customer satisfaction and success',
    skills: ['Customer Support', 'Communication', 'Problem Solving'],
  },
  {
    id: 'u23',
    name: 'Uma Thurman',
    email: 'uma.thurman@company.com',
    avatar: '/avatars/23.jpg',
    role: 'Legal',
    department: 'Legal',
    title: 'Legal Counsel',
    phone: '+1 234 567 8922',
    location: 'Boston, MA',
    status: 'active',
    joinedAt: new Date('2019-06-07'),
    bio: 'Providing legal guidance and support',
    skills: ['Contract Law', 'Compliance', 'Risk Management'],
  },
  {
    id: 'u24',
    name: 'Victor Stone',
    email: 'victor.stone@company.com',
    avatar: '/avatars/24.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'AI/ML Engineer',
    phone: '+1 234 567 8923',
    location: 'Palo Alto, CA',
    status: 'active',
    joinedAt: new Date('2022-10-02'),
    bio: 'Building intelligent systems',
    skills: ['Machine Learning', 'Python', 'TensorFlow'],
  },
  {
    id: 'u25',
    name: 'Wendy Davis',
    email: 'wendy.davis@company.com',
    avatar: '/avatars/25.jpg',
    role: 'Operations',
    department: 'Operations',
    title: 'Operations Manager',
    phone: '+1 234 567 8924',
    location: 'Houston, TX',
    status: 'active',
    joinedAt: new Date('2020-12-16'),
    bio: 'Optimizing processes and operations',
    skills: ['Process Improvement', 'Project Management', 'Analytics'],
  },
  {
    id: 'u26',
    name: 'Xavier Woods',
    email: 'xavier.woods@company.com',
    avatar: '/avatars/26.jpg',
    role: 'Developer',
    department: 'Engineering',
    title: 'Platform Engineer',
    phone: '+1 234 567 8925',
    location: 'Austin, TX',
    status: 'active',
    joinedAt: new Date('2021-08-28'),
    bio: 'Building platform infrastructure',
    skills: ['Platform Engineering', 'Microservices', 'API Design'],
  },
  {
    id: 'u27',
    name: 'Yara Martinez',
    email: 'yara.martinez@company.com',
    avatar: '/avatars/27.jpg',
    role: 'Product Manager',
    department: 'Product',
    title: 'Product Manager',
    phone: '+1 234 567 8926',
    location: 'Miami, FL',
    status: 'away',
    joinedAt: new Date('2022-04-05'),
    bio: 'Shipping products users love',
    skills: ['Product Management', 'Roadmapping', 'User Stories'],
  },
  {
    id: 'u28',
    name: 'Zack Morris',
    email: 'zack.morris@company.com',
    avatar: '/avatars/28.jpg',
    role: 'Intern',
    department: 'Engineering',
    title: 'Engineering Intern',
    phone: '+1 234 567 8927',
    location: 'San Francisco, CA',
    status: 'active',
    joinedAt: new Date('2023-06-01'),
    bio: 'Learning and contributing',
    skills: ['JavaScript', 'React', 'Learning'],
  },
  {
    id: 'u29',
    name: 'Angela Martin',
    email: 'angela.martin@company.com',
    avatar: '/avatars/29.jpg',
    role: 'Finance',
    department: 'Finance',
    title: 'Accountant',
    phone: '+1 234 567 8928',
    location: 'Scranton, PA',
    status: 'active',
    joinedAt: new Date('2019-03-20'),
    bio: 'Managing finances and accounting',
    skills: ['Accounting', 'Financial Reporting', 'Budgeting'],
  },
  {
    id: 'u30',
    name: 'Dwight Schrute',
    email: 'dwight.schrute@company.com',
    avatar: '/avatars/30.jpg',
    role: 'Sales',
    department: 'Sales',
    title: 'Senior Account Executive',
    phone: '+1 234 567 8929',
    location: 'Scranton, PA',
    status: 'active',
    joinedAt: new Date('2018-11-10'),
    bio: 'Top salesperson and beet farmer',
    skills: ['Sales', 'Negotiation', 'Customer Relations'],
  },
];
